import { api } from "@/api/apiClient";

// Cart is stored in the backend as an Order with status = CART.
// One cart per user per business.
// Note: apiClient interceptor already unwraps ApiResponse<T> → T, so no extra .data access needed.

export const cartService = {
  /** Fetch all active carts for the current user (one per business). */
  getAll() {
    return api.get("/orders/cart").then((r) => r ?? []);
  },

  /**
   * Replace all items in the cart for a specific business.
   * items: Array<{ itemName, quantity, unitPrice, notes? }>
   */
  upsert(businessId, items) {
    return api.put(`/orders/cart/${businessId}`, { items });
  },

  /** Delete the cart for a specific business. */
  clear(businessId) {
    return api.delete(`/orders/cart/${businessId}`);
  },

  /**
   * Promote the cart to a real order.
   * payload: { notes? }
   */
  place(businessId, payload) {
    return api.post(`/orders/cart/${businessId}/place`, payload);
  },
};
